import React, {FunctionComponent} from "react";
const klearMap = require('./klearMap.svg') as string;

const styles = require("./klearMapSVG.component.scss");

export const KlearMapSVG: FunctionComponent = () => {
    return (
        <div className={styles.mapContainer}>
            <img className={styles.klearMap} src={klearMap} alt={''}/>
        </div>
    );
};
